import { render, staticRenderFns } from "./Breathe.vue?vue&type=template&id=dcc24004&scoped=true"
import script from "./Breathe.vue?vue&type=script&lang=js"
export * from "./Breathe.vue?vue&type=script&lang=js"
import style0 from "./Breathe.vue?vue&type=style&index=0&id=dcc24004&prod&lang=scss&scoped=true"
import style1 from "./Breathe.vue?vue&type=style&index=1&id=dcc24004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc24004",
  null
  
)

export default component.exports